import { SET_DUE_DATE_BY } from '../mutation-types';

// state
export const state = {
  dueDateBy: null,
};

// mutations
export const mutations = {
  [SET_DUE_DATE_BY](state, dueDateBy) {
    state.dueDateBy = dueDateBy;
  },
};

// actions
export const actions = {
  setDueDateBy({ commit, state, dispatch }, dueDateBy) {
    commit(SET_DUE_DATE_BY, dueDateBy);
  }
};

// getters
export const getters = {
  dueDateBy: state => state.dueDateBy,
};
